import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismIcon, PrismTooltip } from '@mylighthouse/prism-ember';

import styles from './upsell-icon.module.css';

interface HotelBenchmarkInsightUpsellIconSignature {
  Args: {
    tooltipText?: string;
  };
}

export default class HotelBenchmarkInsightUpsellIcon extends Component<HotelBenchmarkInsightUpsellIconSignature> {
  @service('benchmark-insight/features')
  declare benchmarkInsightFeatures: Services['benchmark-insight/features'];

  @service declare usageAnalytics: Services['usage-analytics'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get tooltipText() {
    const { tooltipText } = this.args;

    if (!tooltipText) {
      return this.benchmarkInsightFeatures.beniLightTooltipText;
    }

    return tooltipText;
  }

  @action
  onShowTooltip(): void {
    this.usageAnalytics.track('Upsell Trigger Viewed', {
      eventTrigger: 'upsell-trigger',
      product: 'benchmark-insight',
    });
  }

  <template>
    <div
      class="{{styles.icon}} flex items-center justify-center"
      data-test-id="upsell-icon"
    >
      <PrismIcon @color="default-inverse" @name="rocket" @size="small" />

      <PrismTooltip @onShow={{this.onShowTooltip}} @text={{this.tooltipText}} />
    </div>
  </template>
}
